module.exports = __webpack_public_path__ + "static/media/road-A.2b206bee.svg";